<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#particles-js {
  width: 100%;
  height: 100%;
  position: fixed;
}
html {
  scroll-behavior: smooth;
}
body {
  font-size: 14px;
  line-height: 1.5;
  font-family: "微软雅黑";
}
* {
  box-sizing: border-box;
}
h4,
.h4 {
  font-size: 1.8rem;
  line-height: 1.5;
}
p {
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
.font-lg {
  font-size: 40px;
}
.font-lt-lg {
  font-size: 29px;
}
.font-normal {
  font-size: 16px;
}
.font-s {
  font-size: 14px;
}
.contentWh {
  min-width: 960px;
  max-width: 1240px;
  padding: 0 24px;
  margin: 0 auto;
  position: relative;
}
@media screen and (max-width: 768px) {
  .contentWh {
    width: 100%;
    min-width: auto;
    max-width: auto;
    padding: 0 24px;
    position: relative;
  }
  .font-lg {
    font-size: 20px;
  }
  .font-lt-lg {
    font-size: 18px;
  }
  .font-normal {
    font-size: 14px;
  }
  .font-s {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue